export default __webpack_public_path__ + "static/media/ic_chatbubbles.0e0acdff.svg";